import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./changeAppointmentConfirmationPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";


interface ChangeAppointmentConfirmationPopupProps {
    date1: string;
    date2: string;
    changeAppointment: (deleteType: number) => void;
    onClose: () => void;
}

function ChangeAppointmentConfirmationPopup({ date1, date2, changeAppointment, onClose }: ChangeAppointmentConfirmationPopupProps) {
    return (
        <article className={popupStyles.popup}>
            <div className={popupStyles.popup__title_container}>
                <h2 className={popupStyles.popup__text}>
                    {t("TRANSFER_APPOINTMENT")}                    </h2>
                <h2 className={popupStyles.popup__text}>
                    {t("TRANSFER_APPOINTMENT_FROM")}
                    {date1}
                    {t("TRANSFER_APPOINTMENT_TO")}
                    <b className={popupStyles.popup__text_bold}>{date2}</b>,
                </h2>
                <img
                    src={doctor}
                      alt={t("TRANSFER_APPOINTMENT_IMAGE_ALT")}
                    className={popupStyles.popup__img}
                />
                <h2 className={popupStyles.popup__title}>
                      {t("TRANSFER_APPOINTMENT_QUESTION")}
                </h2>
            </div>


            <div className={popupStyles.popup__nextBtn_container}>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={() => {
                        changeAppointment(2);
                        onClose();
                    }}
                >
                       {t("TRANSFER_APPOINTMENT_YES")}
                </button>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={() => {
                        changeAppointment(1);
                        onClose();
                    }}
                >
                      {t("TRANSFER_APPOINTMENT_NO")}
                </button>
            </div>
        </article>
    );
}

export default ChangeAppointmentConfirmationPopup;
